import React from 'react';
import PageHeader from '../components/PageHeader';
import '../css/deansw.css'; // Update the CSS file name

const Phdwrittentest = () => {
    return (

        <div class="container">

            <div class="row">

                <p>



                    <h4 align='center'>
                        Ph.D. ADMISSIONS JULY, 2025 SESSION
                    </h4>
                    <h5 align='center'><u>
                        SCHEDULE FOR WRITTEN TEST AND INTERVIEW</u>
                    </h5>
                    <ul>
                        <li>•	The written test and interview will be conducted only in physical (offline) mode at NIT Warangal in the respective Departments.</li>
                        <li>•	The list of original certificates to be produced for verification are listed at the end of the document.</li>
                        <li>•	The written test and interview schedule for Ph.D. admissions to various Departments is shown below:</li>
                    </ul>
                    <table class="table table-bordered table-striped table-hover">
                        <thead class="table-dark text-center">
                            <tr>
                                <th scope="col">Sl. No.</th>
                                <th scope="col">Department</th>
                                <th scope="col">Date &amp; Time of Written Test / Interview</th>
                                <th scope="col">Contact Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>1</td><td>Civil Engineering</td><td>13-05-2025</td><td>civil_hod@nitw.ac.in</td></tr>
                            <tr><td>2</td><td>Electrical Engineering</td><td>12-05-2025</td><td>eee_hod@nitw.ac.in</td></tr>
                            <tr><td>3</td><td>Mechanical Engineering</td><td>12-05-2025</td><td>mech_hod@nitw.ac.in</td></tr>
                            <tr><td>4</td><td>Electronics and Communication Engineering</td><td>13-05-2025</td><td>ece_hod@nitw.ac.in</td></tr>
                            <tr><td>5</td><td>Metallurgical and Materials Engineering</td><td>13-05-2025</td><td>mme_hod@nitw.ac.in</td></tr>
                            <tr><td>6</td><td>Chemical Engineering</td><td>14-05-2025</td><td>chemical_hod@nitw.ac.in</td></tr>
                            <tr><td>7</td><td>Computer Science and Engineering</td><td>12-05-2025 &amp; 13-05-2025</td><td>cse_hod@nitw.ac.in</td></tr>
                            <tr><td>8</td><td>Biotechnology</td><td>13-05-2025</td><td>biotech_hod@nitw.ac.in</td></tr>
                            <tr><td>9</td><td>Mathematics</td><td>14-05-2025</td><td>maths_hod@nitw.ac.in</td></tr>
                            <tr><td>10</td><td>Physics</td><td>15-05-2025</td><td>physics_hod@nitw.ac.in</td></tr>
                            <tr><td>11</td><td>Chemistry</td><td>16-05-2025</td><td>chemistry_hod@nitw.ac.in</td></tr>
                            <tr><td>12</td><td>Department of Management Studies</td><td>15-05-2025</td><td>som_hod@nitw.ac.in</td></tr>
                            <tr><td>13</td><td>Humanities and Social Science</td><td>16-05-2025</td><td>humanities_hod@nitw.ac.in</td></tr>
                        </tbody>
                    </table>

                    <h4>
                        LIST OF ELIGIBLE CANDIDATES FOR WRITTEN TEST
                    </h4>
                    <h5><b>Department of Civil Engineering:</b></h5>
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125CE00001</td>
                                <td>PH125CE00019</td>
                                <td>PH125CE00036</td>
                                <td>PH125CE00053</td>
                                <td>PH125CE00076</td>
                            </tr>
                            <tr>
                                <td>PH125CE00007</td>
                                <td>PH125CE00020</td>
                                <td>PH125CE00037</td>
                                <td>PH125CE00057</td>
                                <td>PH125CE00078</td>
                            </tr>
                            <tr>
                                <td>PH125CE00009</td>
                                <td>PH125CE00021</td>
                                <td>PH125CE00038</td>
                                <td>PH125CE00062</td>
                                <td>PH125CE00082</td>
                            </tr>
                            <tr>
                                <td>PH125CE00010</td>
                                <td>PH125CE00025</td>
                                <td>PH125CE00040</td>
                                <td>PH125CE00063</td>
                                <td>PH125CE00083</td>
                            </tr>
                            <tr>
                                <td>PH125CE00011</td>
                                <td>PH125CE00030</td>
                                <td>PH125CE00046</td>
                                <td>PH125CE00066</td>
                                <td>PH125CE00084</td>
                            </tr>
                            <tr>
                                <td>PH125CE00013</td>
                                <td>PH125CE00032</td>
                                <td>PH125CE00048</td>
                                <td>PH125CE00067</td>
                                <td>PH125CE00085</td>
                            </tr>
                            <tr>
                                <td>PH125CE00017</td>
                                <td>PH125CE00034</td>
                                <td>PH125CE00049</td>
                                <td>PH125CE00069</td>
                                <td>PH125CE00089</td>
                            </tr>
                            <tr>
                                <td>PH125CE00018</td>
                                <td>PH125CE00035</td>
                                <td>PH125CE00051</td>
                                <td>PH125CE00074</td>
                                <td>PH125CE00090</td>
                            </tr>


                        </tbody>
                    </table>


                    <h5><b>Department of Electrical Engineering:</b></h5>


                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125EE00004</td>
                                <td>PH125EE00016</td>
                                <td>PH125EE00023</td>
                                <td>PH125EE00035</td>
                                <td>PH125EE00041</td>
                            </tr>
                            <tr>
                                <td>PH125EE00008</td>
                                <td>PH125EE00018</td>
                                <td>PH125EE00025</td>
                                <td>PH125EE00037</td>
                                <td>PH125EE00044</td>
                            </tr>
                            <tr>
                                <td>PH125EE00010</td>
                                <td>PH125EE00019</td>
                                <td>PH125EE00033</td>
                                <td>PH125EE00040</td>
                                <td></td>
                            </tr>


                        </tbody>
                    </table>

                    <h5><b>Department of Mechanical Engineering:</b></h5>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125ME00002</td>
                                <td>PH125ME00010</td>
                                <td>PH125ME00018</td>
                                <td>PH125ME00028</td>
                                <td>PH125ME00036</td>
                            </tr>
                            <tr>
                                <td>PH125ME00003</td>
                                <td>PH125ME00011</td>
                                <td>PH125ME00019</td>
                                <td>PH125ME00029</td>
                                <td>PH125ME00038</td>
                            </tr>
                            <tr>
                                <td>PH125ME00004</td>
                                <td>PH125ME00012</td>
                                <td>PH125ME00024</td>
                                <td>PH125ME00031</td>
                                <td>PH125ME00041</td>
                            </tr>
                            <tr>
                                <td>PH125ME00007</td>
                                <td>PH125ME00016</td>
                                <td>PH125ME00026</td>
                                <td>PH125ME00032</td>
                                <td>PH125ME00044</td>
                            </tr>
                            <tr>
                                <td>PH125ME00008</td>
                                <td>PH125ME00017</td>
                                <td>PH125ME00027</td>
                                <td>PH125ME00033</td>
                                <td>PH125ME00048</td>
                            </tr>
                            <tr>
                               
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>PH125ME00049</td>
                            </tr>


                        </tbody>
                    </table>


                    <h5><b>Department of Electronics and Communications Engineering:</b></h5>



                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125EC00002</td>
                                <td>PH125EC00020</td>
                                <td>PH125EC00051</td>
                                <td>PH125EC00074</td>
                                <td>PH125EC00088</td>
                            </tr>
                            <tr>
                                <td>PH125EC00004</td>
                                <td>PH125EC00024</td>
                                <td>PH125EC00052</td>
                                <td>PH125EC00075</td>
                                <td>PH125EC00089</td>
                            </tr>
                            <tr>
                                <td>PH125EC00006</td>
                                <td>PH125EC00034</td>
                                <td>PH125EC00054</td>
                                <td>PH125EC00076</td>
                                <td>PH125EC00097</td>
                            </tr>
                            <tr>
                                <td>PH125EC00007</td>
                                <td>PH125EC00044</td>
                                <td>PH125EC00064</td>
                                <td>PH125EC00081</td>
                                <td>PH125EC00098</td>
                            </tr>
                            <tr>
                                <td>PH125EC00012</td>
                                <td>PH125EC00045</td>
                                <td>PH125EC00067</td>
                                <td>PH125EC00083</td>
                                <td>PH125EC00099</td>
                            </tr>
                            <tr>
                                <td>PH125EC00015</td>
                                <td>PH125EC00047</td>
                                <td>PH125EC00070</td>
                                <td>PH125EC00086</td>
                                <td>PH125EC00100</td>
                            </tr>


                        </tbody>
                    </table>




                    <h5><b>Department of Metallurgical and Materials Engineering:</b></h5>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125MM00001</td>
                                <td>PH125MM00005</td>
                                <td>PH125MM00008</td>
                                <td>PH125MM00012</td>
                                <td>PH125MM00014</td>
                            </tr>
                            <tr>
                                <td>PH125MM00002</td>
                                <td>PH125MM00006</td>
                                <td>PH125MM00010</td>
                                <td>PH125MM00013</td>
                                <td>PH125MM00016</td>
                            </tr>


                        </tbody>
                    </table>



                    <h5><b>Department of Chemical Engineering:</b></h5>



                    <table className="table table-bordered">
                        <tbody>

                            <tr>
                                <td>PH125CH00001</td>
                                <td>PH125CH00005</td>
                                <td>PH125CH00008</td>
                                <td>PH125CH00011</td>
                                <td>PH125CH00013</td>
                            </tr>
                            <tr>
                                <td>PH125CH00003</td>
                                <td>PH125CH00006</td>
                                <td>PH125CH00009</td>
                                <td>PH125CH00012</td>
                                <td>PH125CH00016</td>
                            </tr>
                            <tr>
                               
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>PH125CY00026</td>
                            </tr>

                        </tbody>
                    </table>



                    <h5><b>Department of Computer Science and Engineering:</b></h5>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125CS00003</td>
                                <td>PH125CS00079</td>
                                <td>PH125CS00154</td>
                                <td>PH125CS00235</td>
                                <td>PH125CS00287</td>
                            </tr>
                            <tr>
                                <td>PH125CS00004</td>
                                <td>PH125CS00085</td>
                                <td>PH125CS00157</td>
                                <td>PH125CS00238</td>
                                <td>PH125CS00298</td>
                            </tr>
                            <tr>
                                <td>PH125CS00006</td>
                                <td>PH125CS00086</td>
                                <td>PH125CS00162</td>
                                <td>PH125CS00240</td>
                                <td>PH125CS00299</td>
                            </tr>
                            <tr>
                                <td>PH125CS00008</td>
                                <td>PH125CS00095</td>
                                <td>PH125CS00171</td>
                                <td>PH125CS00241</td>
                                <td>PH125CS00300</td>
                            </tr>
                            <tr>
                                <td>PH125CS00013</td>
                                <td>PH125CS00103</td>
                                <td>PH125CS00176</td>
                                <td>PH125CS00245</td>
                                <td>PH125CS00304</td>
                            </tr>
                            <tr>
                                <td>PH125CS00014</td>
                                <td>PH125CS00106</td>
                                <td>PH125CS00186</td>
                                <td>PH125CS00255</td>
                                <td>PH125CS00313</td>
                            </tr>
                            <tr>
                                <td>PH125CS00027</td>
                                <td>PH125CS00107</td>
                                <td>PH125CS00196</td>
                                <td>PH125CS00256</td>
                                <td>PH125CS00315</td>
                            </tr>
                            <tr>
                                <td>PH125CS00028</td>
                                <td>PH125CS00108</td>
                                <td>PH125CS00198</td>
                                <td>PH125CS00257</td>
                                <td>PH125CS00316</td>
                            </tr>
                            <tr>
                                <td>PH125CS00036</td>
                                <td>PH125CS00110</td>
                                <td>PH125CS00206</td>
                                <td>PH125CS00258</td>
                                <td>PH125CS00317</td>
                            </tr>
                            <tr>
                                <td>PH125CS00041</td>
                                <td>PH125CS00114</td>
                                <td>PH125CS00207</td>
                                <td>PH125CS00265</td>
                                <td>PH125CS00319</td>
                            </tr>
                            <tr>
                                <td>PH125CS00044</td>
                                <td>PH125CS00120</td>
                                <td>PH125CS00208</td>
                                <td>PH125CS00268</td>
                                <td>PH125CS00322</td>
                            </tr>
                            <tr>
                                <td>PH125CS00046</td>
                                <td>PH125CS00132</td>
                                <td>PH125CS00209</td>
                                <td>PH125CS00273</td>
                                <td>PH125CS00323</td>
                            </tr>
                            <tr>
                                <td>PH125CS00053</td>
                                <td>PH125CS00136</td>
                                <td>PH125CS00210</td>
                                <td>PH125CS00277</td>
                                <td>PH125CS00325</td>
                            </tr>
                            <tr>
                                <td>PH125CS00057</td>
                                <td>PH125CS00138</td>
                                <td>PH125CS00212</td>
                                <td>PH125CS00283</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>PH125CS00062</td>
                                <td>PH125CS00142</td>
                                <td>PH125CS00218</td>
                                <td>PH125CS00284</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>PH125CS00075</td>
                                <td>PH125CS00146</td>
                                <td>PH125CS00227</td>
                                <td>PH125CS00286</td>
                                <td></td>
                            </tr>



                        </tbody>
                    </table>





                    <h5><b>Department of Biotechnology:</b></h5>


                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125BT00004</td>
                                <td>PH125BT00015</td>
                                <td>PH125BT00081</td>
                                <td>PH125BT00094</td>
                                <td>PH125BT00113</td>
                            </tr>
                            <tr>
                                <td>PH125BT00010</td>
                                <td>PH125BT00032</td>
                                <td>PH125BT00087</td>
                                <td>PH125BT00095</td>
                                <td>PH125BT00118</td>
                            </tr>
                            <tr>
                                <td>PH125BT00011</td>
                                <td>PH125BT00060</td>
                                <td>PH125BT00089</td>
                                <td>PH125BT00105</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>PH125BT00012</td>
                                <td>PH125BT00080</td>
                                <td>PH125BT00090</td>
                                <td>PH125BT00112</td>
                                <td></td>
                            </tr>


                        </tbody>
                    </table>




                    <h5><b>Department of Mathematics:</b></h5>



                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125MA00002</td>
                                <td>PH125MA00012</td>
                                <td>PH125MA00027</td>
                                <td>PH125MA00042</td>
                                <td>PH125MA00055</td>
                            </tr>
                            <tr>
                                <td>PH125MA00005</td>
                                <td>PH125MA00013</td>
                                <td>PH125MA00033</td>
                                <td>PH125MA00051</td>
                                <td>PH125MA00059</td>
                            </tr>
                            <tr>
                                <td>PH125MA00006</td>
                                <td>PH125MA00016</td>
                                <td>PH125MA00040</td>
                                <td>PH125MA00053</td>
                                <td>PH125MA00060</td>
                            </tr>


                        </tbody>
                    </table>



                    <h5><b>Department of Physics:</b></h5>



                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125PH00003</td>
                                <td>PH125PH00010</td>
                                <td>PH125PH00020</td>
                                <td>PH125PH00026</td>
                                <td>PH125PH00032</td>
                            </tr>
                            <tr>
                                <td>PH125PH00006</td>
                                <td>PH125PH00017</td>
                                <td>PH125PH00021</td>
                                <td>PH125PH00027</td>
                                <td>PH125PH00037</td>
                            </tr>
                            <tr>
                                <td>PH125PH00008</td>
                                <td>PH125PH00018</td>
                                <td>PH125PH00023</td>
                                <td>PH125PH00028</td>
                                <td>PH125PH00040</td>
                            </tr>

                        </tbody> </table>



                    <h5><b>Department of Chemistry:</b></h5>






                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125CY00013</td>
                                <td>PH125CY00021</td>
                                <td>PH125CY00023</td>
                                <td>PH125CY00045</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>PH125CY00020</td>
                                <td>PH125CY00022</td>
                                <td>PH125CY00038</td>
                                <td>PH125CY00057</td>
                                <td></td>
                            </tr>


                        </tbody> </table>






                    <h5><b>Department of Management Studies:</b></h5>


                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td>PH125MS00001</td>
                                <td>PH125MS00012</td>
                                <td>PH125MS00031</td>
                                <td>PH125MS00038</td>
                                <td>PH125MS00047</td>
                            </tr>
                            <tr>
                                <td>PH125MS00002</td>
                                <td>PH125MS00017</td>
                                <td>PH125MS00032</td>
                                <td>PH125MS00039</td>
                                <td>PH125MS00049</td>
                            </tr>
                            <tr>
                                <td>PH125MS00004</td>
                                <td>PH125MS00023</td>
                                <td>PH125MS00033</td>
                                <td>PH125MS00043</td>
                                <td>PH125MS00050</td>
                            </tr>
                            <tr>
                                <td>PH125MS00007</td>
                                <td>PH125MS00024</td>
                                <td>PH125MS00036</td>
                                <td>PH125MS00045</td>
                                <td>PH125MS00051</td>
                            </tr>
                            <tr>
                                <td>PH125MS00008</td>
                                <td>PH125MS00030</td>
                                <td>PH125MS00037</td>
                                <td>PH125MS00046</td>
                                <td>PH125MS00052</td>
                            </tr>


                        </tbody></table>


                    <h5><b>Department of Humanities and Social Sciences:</b></h5>

                    <table className="table table-bordered"> <tbody>
                        <tr>
                            <td>PH125HS00001</td>
                            <td>PH125HS00005</td>
                            <td>PH125HS00012</td>
                            <td>PH125HS00017</td>
                            <td>PH125HS00022</td>
                        </tr>
                        <tr>
                            <td>PH125HS00002</td>
                            <td>PH125HS00009</td>
                            <td>PH125HS00013</td>
                            <td>PH125HS00018</td>
                            <td>PH125HS00023</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>PH125HS00025</td>
                        </tr>



                    </tbody> </table>

                    <h5><b>Note:</b></h5>
                    <ol>
                        <p>1. The candidates shall come prepared to stay for one day extra, if required.</p>
                        <p>2. The accommodation details in the Institute Guest house on payment basis are available at: <a href="https://nitw.ac.in/page/?url=/guesthouse/2021" target="_blank">https://nitw.ac.in/page/?url=/guesthouse/2021</a></p>
                        <p>3. Hotels are also available near the Institute.</p>

                    </ol>

                    <h4>ORIGINAL CERTIFICATES TO BE PRODUCED FOR VERIFICATION</h4>

                    <h5>FULL-TIME CANDIDATES (Institute Fellowship):</h5>

                    <ul>
                        <li>&#8226; SSC/ Class X certificate in support of Date of Birth.</li>
                        <li>&#8226; Intermediate/ (10+2)/ Class XII certificate.</li>
                        <li>&#8226; Provisional Certificate / Degree Certificate (both UG & PG) / Course Completion Certificate for PG / Certificate from the current Institute mentioning the expected date of results publication, if final examinations are not completed.</li>
                        <li>&#8226; Marks Sheets of the qualifying Examinations (both UG & PG). If final examinations are not completed, marks sheets up to previous semester shall be produced.</li>
                        <li>&#8226; Caste certificate (in case of SC/ ST candidates).</li>
                        <li>&#8226; PwD certificate, if applicable.</li>
                        <li>&#8226; For GEN-EWS candidates, selected candidates are required to produce the GEN-EWS certificate issued on or after April 1, 2025.</li>
                        <li>&#8226; For OBC-NCL candidates, selected candidates are required to produce the OBC-NCL certificate issued on or after April 1, 2025.</li>
                        <li>&#8226; No Objection Certificate from the employer (if employed) issued on or after 10.03.2025 only is acceptable (Annexure-III).</li>
                        <li>&#8226; Photograph on application form.</li>
                        <li>&#8226; Grade/ Rank Card of GATE or UGC-NET or CAT or GMAT or CSIR or GPAT (as applicable).</li>
                        <li>&#8226; Application fee payment receipt with transaction number.</li>
                        <li>&#8226; Statement of Proposal (Research Proposal).</li>
                        <li>&#8226; Any other documents (List of publications, etc.).</li>
                    </ul>
                    <h4>FULL-TIME CANDIDATES (Self-Finance):</h4>
                    <ul>
                        <li>&#8226; SSC/ Class X certificate in support of Date of Birth.</li>
                        <li>&#8226; Intermediate/ (10+2)/ Class XII certificate.</li>
                        <li>&#8226; Provisional Certificate/ Degree Certificate (both UG & PG) / Course Completion Certificate for PG / Certificate from the current Institute mentioning the expected date of results publication, if final examinations are not completed.</li>
                        <li>&#8226; Marks Sheets of the qualifying Examinations (both UG & PG). If final examinations are not completed, marks sheets up to previous semester shall be produced.</li>
                        <li>&#8226; No Objection Certificate from the employer (if employed) issued on or after 10.03.2025 <span style={{color:"red"}}> (as per Annexure-III)</span>.</li>
                        <li>&#8226; Application fee payment receipt with transaction number.</li>
                        <li>&#8226; Statement of Proposal (Research Proposal).</li>
                        <li>&#8226; Any other documents (List of publications, etc.).</li>
                    </ul>
                    <h4>PART-TIME CANDIDATES:</h4>
                    <ul>
  <li>&#8226; SSC/ Class X certificate in support of Date of Birth.</li>
  <li>&#8226; Intermediate/ (10+2)/ Class XII certificate.</li>
  <li>&#8226; Provisional Certificate/ Degree Certificate (both UG & PG) / Course Completion Certificate for PG / Certificate from the current Institute mentioning the expected date of results publication, if final examinations are not completed.</li>
  <li>&#8226; Marks Sheets of the qualifying Examinations (both UG & PG). If final examinations are not completed, marks sheets up to previous semester shall be produced.</li>
  <li>&#8226; No Objection Certificate from the employer issued on or after 10.03.2025<span style={{color:"red"}}> (as per Annexure-III)</span>.</li>
  <li>&#8226; Application fee payment receipt with transaction number.</li>
  <li>&#8226; Statement of Proposal (Research Proposal).</li>
  <li>&#8226; Any other documents (List of publications, etc.).</li>
</ul>








                    {/* <br></br>
                    <br></br>
                    <b>Associate Dean Admissions      </b>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <b>DEAN, ACADEMIC</b>
                    <br></br>
                    <br></br> */}
                </p>

            </div>
        </div>
    );
};

export default Phdwrittentest;